import {AuthActions} from '@spartacus/core';
import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {CardPaymentSessionStorageService} from '../../../payment/services/card-payment-session-storage.service';
import {switchMap, tap} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable()
export class CardPaymentEffects {
  constructor(private actions$: Actions, private cardPaymentHelperService: CardPaymentSessionStorageService) {}

  /**
   * clear cvv from sessionStorage when user logs off
   */
  clearCvv$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      tap(() => this.cardPaymentHelperService.clearCvv()),
      switchMap(() => of({type: '[Cvv] Cleared after logout'}))
    )
  );

  /**
   * clear authorize jwt from sessionStorage when user logs off
   */
  clearAuthorizeJwt$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.LOGOUT),
      tap(() => this.cardPaymentHelperService.clearAuthorizeJwt()),
      switchMap(() => of({type: '[AuthorizeJwt] Cleared after logout'}))
    )
  );
}
